import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { PendingStopCard, PendingStopCardModel } from "./managecards";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./managedcards.pendingcards.component.html"
})
export class PendingCardsComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'pendingcards';
  public pendingStopCardsList: PendingStopCard[];
  public accessAccounts: IAccount[];

  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.loadPendingStopCardsList();
  }
  ngAfterViewInit(): void {
    $.extend($.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
      }
    });
  }

  loadPendingStopCardsList() {
    this.loaderService.display(true);
    var model: PendingStopCardModel = new PendingStopCardModel();
    model.AccountNumbers = [];
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.PendingStopCardsEndPoint;
    this.accessAccounts.forEach(item => {
      model.AccountNumbers.push(item.name);
    });
    this.managedCardService.getPendingStopCards(model)
      .subscribe(
      (pendingStopCards: PendingStopCard[]) => {
        this.pendingStopCardsList = pendingStopCards;
        setTimeout(() => {
          this.afterloaddata();
          this.loaderService.display(false);
        }, 100);
      },
      (error: any) => {
        this.loaderService.display(false);
        this.managedCardService.showError("Pending Stop Cards retrieval problem", <any>error);
      }
    );
  }

  afterloaddata() {
    $('#pendingcardsdatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"fip<"clear">>rt<"bottom"ip<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ "type": "non-empty-string", targets: [2,3] }],
      fixedColumns: true,
    });


    // DataTable
    var table = $('#pendingcardsdatatable').DataTable();

    // Apply the search
    table.columns().every(function () {
      var that = this;

      $('input', this.footer()).on('keyup change', function () {
        if (that.search() !== this.value) {
          that
            .search(this.value)
            .draw();
        }
      });
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.pendingcards.component.ts